import React from "react";

const ActiveOrdersContext = React.createContext();

export const ActiveOrdersProvider = ActiveOrdersContext.Provider;
export const ActiveOrdersConsumer = ActiveOrdersContext.Consumer;
export default ActiveOrdersContext;
